import Button from "@/common/components/Button";
import ButtonLink from "@/common/components/ButtonLink";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { formatDateTime } from "@/common/utils/formatters";
import { maintenanceWorkflowStatus } from "@/features/privateCompanies/constants/maintenance/workflows/maintenanceWorkflowsStatus.constant";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/constants/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { MaintenaceWorkflowData } from "@/features/privateCompanies/types/maintenance/workflows/maintenanceWorkflows.type";
import { ArrowBigRightIcon, CarFrontIcon, UserRoundIcon } from "lucide-react";
import { Link } from "react-router-dom";

export class MaintenanceWorkflowsTransformer {

  static tableTransformer(companyId: string | undefined) {
    return (workflows: MaintenaceWorkflowData[]) => {
      return workflows.map((workflow) => {
        const directiveEntryData = workflow.current_forwarding && maintenanceForwardingsDirectiveEntryKlasses[workflow.current_forwarding.directive_entry_type];

        return {
          status: maintenanceWorkflowStatus[workflow.status] || workflow.status,
          current_forwarding: workflow.current_forwarding ? (
            <div className="flex flex-col">
              <p>
                {directiveEntryData?.label || '--'}
              </p>

              {workflow.current_forwarding.status && (
                <p className="text-xs italic">
                  {directiveEntryData?.status[workflow.current_forwarding.status]?.label || workflow.current_forwarding.status}
                </p>
              )}
            </div>
          ) : (
            <p className="italic text-sm text-white-400">
              Encaminhamento pendente
            </p>
          ),
          process_id: (
            <div className="flex flex-col">
              <p>
                {workflow.id.split('-')[0].toUpperCase()}
              </p>

              <p className="text-xs italic">
                {formatDateTime(new Date(workflow.created_at))}
              </p>
            </div>
          ),
          observations: workflow.observations,
          equipment: (
            <ButtonLink
              linkTo={`/companies/${companyId}/equipments/${workflow.equipment.id}`}
              operationKlassToCheckPermission="Admin::Client::Equipments::Show"
            >
              <ImageWithDisplayName
                placeholderIcon={CarFrontIcon}
                imageUrl={workflow.equipment?.photos?.[0]?.url}
                displayName={workflow.equipment?.field_for_display_value}
              />
            </ButtonLink>
          ),
          branch: (
            <ButtonLink
              linkTo={`/companies/${companyId}/branches/${workflow.equipment.branch.id}`}
            >
              {workflow.equipment?.branch?.display_name}
            </ButtonLink>
          ),
          creator: workflow.creator ? (
            <ImageWithDisplayName
              placeholderIcon={UserRoundIcon}
              imageUrl={workflow.creator?.profile_picture?.url}
              displayName={workflow.creator?.full_name}
            />
          ) : '--',
          actions: (
            <Link to={workflow.id}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Admin::Maintenance::Workflows::Show"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        };
      });
    }
  }

}
